// extracted by mini-css-extract-plugin
module.exports = {"host":"_25LHM6VtHy8JcYJwYD7ube"};